export type LimaBenarKey =
  | "benar_pasien"
  | "benar_obat"
  | "benar_dosis"
  | "benar_waktu"
  | "benar_rute";

export interface LimaBenarItem {
  key: LimaBenarKey;
  label: string;
}

export const LIMA_BENAR: LimaBenarItem[] = [
  { key: "benar_pasien", label: "Benar pasien" },
  { key: "benar_obat", label: "Benar obat" },
  { key: "benar_dosis", label: "Benar dosis" },
  { key: "benar_waktu", label: "Benar waktu" },
  { key: "benar_rute", label: "Benar rute" }
];
